import { FC } from "react";
import { Outlet } from "react-router-dom";

/** 根路径下区分公开入口与需登录的后台布局 */
const RootOutlet: FC = () => <Outlet />;

export default RootOutlet;
